import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
// import TextField from "@mui/material/TextField";
import TextField from '@mui/material/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "#000000",
    fontFamily: '"Source Sans Pro",sans-serif',
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-root": {
      height: "45px",
    },
    "& .MuiInputBase-multiline": {
      height: "auto",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
    "& .MuiInputLabel-outlined": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
      transform: "translate(14px, 13px) scale(1)",
      color: "rgba(0, 0, 0, 0.54) !important",
    },
    "& .Mui-disabled": {
      color: "#000000",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#605f70',
      },
      '&.Mui-error fieldset': {
        borderColor: '#d32f2f',
      },
    },
  },
}));

export default function TextInput(props) {
  const {
    inputTitle,
    textInput,
    handleTextInputChange,
    name,
    isRequired,
    multiline,
    rows,
    disabled,
    maxLength,
    autoFocus,
    error,
  } = props;

  const classes = useStyles();
  return (
    <div className={classes.input}>
      {/* <div className={classes.inputTitle}>{inputTitle}</div> */}
      <TextField
        variant="outlined"
        id="standard-helperText"
        // label=""
        label={inputTitle}
        name={name}
        style={{ margin: "2px 8px" }}
        className={classes.textField}
        value={textInput}
        onChange={handleTextInputChange}
        required={isRequired}
        autoFocus={autoFocus}
        multiline={multiline}
        rows={rows}
        disabled={disabled}
        inputProps={{
          maxLength: maxLength
        }}
        error={error}
      />
    </div>
  );
}

TextInput.defaultProps = {
  isRequired: false,
  autoFocus: false,
  error: false,
  maxLength: 255
};

TextInput.propTypes = {
  maxLength: PropTypes.any,
  isRequired: PropTypes.bool,
  inputTitle: PropTypes.any,
  textInput: PropTypes.any,
  handleTextInputChange: PropTypes.any,
  autoFocus: PropTypes.bool,
  error: PropTypes.bool,
};
